module.exports = __webpack_public_path__ + "img/icon-limbs-tab.55de151c.png";